// Standard
import "bootstrap";

// Custom
import "./custom.js";

// Modules
import "./modules/hero-slider/hero-slider.js";  

import "./modules/gallery/gallery.js";  
import "./modules/news/news.js";
import "./modules/immo/immo-map.js";
import "./modules/immo/immo-map-iframe.js";
import "./modules/sidenav/sidenav.js";
import "./modules/show-condition";
import "./modules/datepicker";
// import "../node_modules/flickity/dist/flickity.pkgd";


